import {createFlag} from "./createFlag";

export const Flags = {
    PRIVATE_SHARES_STARTPAGE: createFlag("private_shares_startpage", {
        variations: ["off", "20_to_49", "50_and_above"],
        fallbackVariation: "off",
    }),
    SERVER_CLOUD_ASSETS: createFlag("server_cloud_assets", {
        fallbackVariation: "off",
    }),
    CASINO_RAPID_JACKPOT: createFlag("casino_rapid_jackpot", {
        fallbackVariation: "off",
    }),
    CASINO_NOTIFICATIONS: createFlag("casino_notifications", {
        fallbackVariation: "off",
    }),
    MINIMIZED_CASINO_GAMECARDS: createFlag("minimized_casino_gamecards", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    CASINO_GAME_CARD_POPOVER_DEEMPHASIZE_PROVA_GRATIS: createFlag(
        "casino_game_card_popover_deemphasize_prova_gratis",
        {
            variations: ["off", "old_prova_gratis", "deemphasize_prova_gratis"],
            fallbackVariation: "off",
        },
    ),
    CASINO_OPEN_SEARCH_VARIATIONS: createFlag("casino_open_search_variations", {
        variations: [
            "off",
            "sticky_search_icon",
            "floating_search_icon",
            "bottom_nav_search_icon",
        ],
        fallbackVariation: "off",
    }),
    CASINO_GAME_RECOMMENDATIONS: createFlag("casino_game_recommendations", {
        fallbackVariation: "off",
    }),
    CASINO_APP_DISABLED_PAGE: createFlag("casino_app_disabled_page", {
        fallbackVariation: "off",
    }),
    CONTENTFUL_ERROR_LOGGING: createFlag("contentful_error_logging", {
        fallbackVariation: "on",
    }),
    ELLI_CUSTOMER_SERVICE: createFlag("elli_customer_service", {
        fallbackVariation: "on",
    }),
    ELLI_NEW_AWS_URL: createFlag("elli_new_aws_url", {
        fallbackVariation: "off",
    }),
    HORSE_ELLI: createFlag("horse_elli", {
        fallbackVariation: "on",
    }),
    HORSE_ELLI_ADMIN: createFlag("horse_elli_admin", {
        fallbackVariation: "off",
    }),
    CUSTOM_SUBTITLES: createFlag("videoplayer_vod_subtitles", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    VINDRAL_CHANNELS: createFlag("videoplayer_vindral_channels", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    HORSE_RACING_INFO_HORSES_AND_STARTS: createFlag(
        "horse_racing_info_horses_and_starts",
        {
            fallbackVariation: "off",
        },
    ),
    HORSE_CC_TEP_CLOUD: createFlag("horse_cc_tep_cloud", {
        fallbackVariation: "off",
    }),
    HORSE_ENABLE_V75: createFlag("horse_enable_v75", {
        fallbackVariation: "off",
    }),
    HORSE_ALLOW_TOP_POOL_BETTING: createFlag("allow_top_pool_betting", {
        fallbackVariation: "off",
    }),
    /**
     * [PEGASUS-1309] Enable champions (vm) marketing modals
     */
    CHAMPIONS_MARKETING_CAMPAIGN: createFlag("champions_marketing_campaign", {
        fallbackVariation: "off",
    }),
    LIVE_CHAT_EMOJI_REACTIONS: createFlag("chatReactions", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    LIVE_CHAT_ACTIVE_USERS: createFlag("chatActiveUsers", {
        variations: ["on", "off"],
    }),
    // [PEGASUS-2503] Add VM in left-hand menu
    /**
     * Feature flag for VXY Product Pages V2 rollout (GS75, V64, V65, V86).
     * V85 is always V2 (not gated by this flag).
     */
    VXY_PRODUCT_PAGES_V2: createFlag("vxy_product_pages_v2", {
        fallbackVariation: "off",
    }),
    // [PEGASUS-2503] Add VM additional features in left-hand menu
    CHAMPIONS_ADDITIONAL_FEATURES: createFlag("champions_additional_features", {
        fallbackVariation: "off",
    }),
    // [PEGASUS-2612] Add VM in left-hand menu
    CHAMPIONS_MENU_ITEM: createFlag("champions_menu_item", {
        fallbackVariation: "off",
    }),
    /**
     * [PEGASUS-2644] Gradual rollout of Receipt v2 (`@atg-horse-shared/receipts`).
     * When `on`, the new `BetReceipt` renders in horse bet history.
     * Default `off` — legacy `@atg-horse/bet-history-receipts` keeps rendering.
     */
    RECEIPTS_V2_ENABLED: createFlag("horse_receipts_v2", {
        fallbackVariation: "off",
    }),
    CHAMPIONS_LIVECHAT: createFlag("champions_livechat", {
        fallbackVariation: "off",
    }),
    HORSE_STARTLIST_RANKING: createFlag("horse_startlist_ranking", {
        fallbackVariation: "off",
    }),

    HORSE_NPF_HARRY_AND_PRIVATE_NON_V85: createFlag(
        "horse_npf_harry_and_private_non_v85",
        {
            variations: ["off", "on"],
            fallbackVariation: "off",
        },
    ),
    APP_NOTIFICATIONS_API_V1: createFlag("app_notifications_api_v1", {
        fallbackVariation: "off",
    }),
    APP_NOTIFICATIONS_V64: createFlag("app_notifications_v64", {
        fallbackVariation: "off",
    }),
    APP_NOTIFICATIONS_V65: createFlag("app_notifications_v65", {
        fallbackVariation: "off",
    }),
    APP_NOTIFICATIONS_V75: createFlag("app_notifications_v75", {
        fallbackVariation: "off",
    }),
    APP_NOTIFICATIONS_V86: createFlag("app_notifications_v86", {
        fallbackVariation: "off",
    }),
    APP_NOTIFICATIONS_GS75: createFlag("app_notifications_gs75", {
        fallbackVariation: "off",
    }),
    // This feature toggle is used to disable usage of cloud assets from server-side entirely.
    // It is used in combination with the "server_cloud_assets" toggle on the client-side
    // which controls which users should be served cloud assets (both toggles must be ON for a user to get cloud assets).
    PAW_SERVER_CLOUD_ASSETS_ENABLED: createFlag("paw_cloud_assets_enabled", {
        fallbackVariation: "on",
    }),
    PAW_CLOUD_WEBSERVER_ENABLED: createFlag("paw_cloud_webserver_enabled", {
        fallbackVariation: "off",
    }),
    SPORT_CROSS_SELL: createFlag("sport_cross_sell", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    SPORT_NEW_POOL_DESIGN: createFlag("sport_new_pool_design", {
        fallbackVariation: "off",
    }),
    SPORT_PLAYER_COUNT: createFlag("sport_player_count", {
        fallbackVariation: "off",
    }),
    SPORT_START_PAGE_ORDER: createFlag("sport_start_page_order", {
        variations: ["off", "variation_1"],
        fallbackVariation: "off",
    }),
    SPORT_WORLD_CUP_QUICKLINKS: createFlag("sport_world_cup_quicklinks", {
        variations: ["off", "variation_1", "variation_2"],
        fallbackVariation: "off",
    }),
    SPORT_CUSTOM_PAGE_BANNER: createFlag("sport_custom_page_banner", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    SPORT_MATCHCOMMENTS_FROM_HORSE_SPACE: createFlag(
        "sport_matchcomments_from_horse_space",
        {
            fallbackVariation: "off",
        },
    ),
    SPORT_A_A_TEST: createFlag("sport_a_a_test", {
        variations: ["variation_1", "variation_2"],
        fallbackVariation: "variation_1",
    }),
    SPORT_HARRY_BOY_POPULAR_BANNER: createFlag("sport_harry_boy_popular_banner", {
        variations: ["off", "variation_1", "variation_2"],
        fallbackVariation: "off",
    }),
    SPORT_WEBVIEW_POOL: createFlag("sport_webview_pool", {
        fallbackVariation: "off",
    }),
    NEW_BIG_9: createFlag("new_big_9", {
        fallbackVariation: "off",
    }),
    MOBILE_NAV_LOGIN_BUTTON: createFlag("mobile_nav_login_button", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    SESSION_REMINDER_DEBUGGER: createFlag("session_reminder_debugger", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    SHORT_SESSION_REMINDER: createFlag("short_session_reminder", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    SESSION_REMINDER_MODAL: createFlag("session_reminder_modal", {
        variations: ["on", "off"],
        fallbackVariation: "on",
    }),
    NEW_USER_AUTH_ENDPOINT: createFlag("new_user_auth_endpoint", {
        fallbackVariation: "off",
    }),
    HARRY_BOY_FLAVOURS: createFlag("harry_boy_flavours", {
        fallbackVariation: "off",
    }),
    TILLSAMMANS_BETA_ONBOARDING: createFlag("tillsammans_beta_onboarding", {
        fallbackVariation: "off",
    }),
    TILLSAMMANS_NOTIFICATIONS: createFlag("tillsammans_notifications", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    HORSE_EXPANDED_FRACTION_OFFERING: createFlag("horse_expanded_fraction_offering", {
        fallbackVariation: "off",
    }),
    SHOPSHARES_PDF_TEMPLATES: createFlag("shopshares_pdf_templates", {
        fallbackVariation: "off",
    }),
    SHOPSHARES_NEW_LANDING_PAGE: createFlag("shopshares_new_landing_page", {
        fallbackVariation: "off",
    }),
    SHOPSHARES_NEW_V75: createFlag("shopshares_new_v75", {
        fallbackVariation: "off",
    }),
    HORSE_HEAD_TO_HEAD: createFlag("horse_head_to_head", {
        fallbackVariation: "off",
    }),

    NEW_CONTENTFUL_COUPON_AB_TEST: createFlag("new_contentful_coupon_ab_test", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),

    MOBILEAPP_QUICK_REPLAY_A_B_TEST: createFlag("mobileapp_quick_replay_a_b_test", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    // TEMP: toggles Curity/Login endpoints between legacy (hh.atg.se) and
    // new cloud (c1.atg.*) hosts during cutover. Safe to remove once verified.
    CLOUD_CURITY: createFlag("cloud_curity", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    MOBILE_APP_RADAR: createFlag("mobile_app_radar", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    MOBILE_APP_TEST_POLLING_FLAGS: createFlag("mobile_app_test_polling_flags", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    MOBILE_APP_MORE_ENHANCED_VIDEO: createFlag("mobile_app_more_enhanced_video", {
        fallbackVariation: "off",
    }),
    MOBILE_APP_SENTRY_ERROR_BOUNDARY: createFlag("mobile_app_sentry_error_boundary", {
        fallbackVariation: "off",
    }),
    MOBILE_APP_SHOW_USERNAME_AND_PASSWORD: createFlag("username_and_password_login_app", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    USERNAME_AND_PASSWORD_LOGIN: createFlag("username_and_password_login", {
        fallbackVariation: "off",
    }),
    MOBILE_APP_HEAD_TO_HEAD: createFlag("mobile_app_h2h", {
        variations: ["on", "off"],
    }),
    HORSE_RECEIPTS_V2: createFlag("horse_receipts_v2", {
        fallbackVariation: "off",
    }),
    RG_REGISTRATION_DEPOSIT_LIMIT_AB_TEST: createFlag(
        "rg_registration_deposit_limit_ab_test",
        {
            variations: ["on", "off"],
            fallbackVariation: "off",
        },
    ),
    HARRY_BOY_2_0: createFlag("harry_boy_2_0", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    STARTPAGE: createFlag("startpage", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    RECEIPT_VIDEOPLAYER_V2: createFlag("receipt_videoplayer_v2", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    PAW_CROWDIN_IN_CONTEXT_TOOL: createFlag("paw_crowdin_in_context_tool", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    HORSE_WEB_H2H_HIGHLIGHTED_BETS: createFlag("horse_web_h2h_highlighted_bets", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    SPORT_STATIC_PAGES_CONTENTFUL_MIGRATION: createFlag(
        "sport_static_pages_contentful_migration",
        {
            fallbackVariation: "off",
        },
    ),
    SPORT_POOL_MATCH_COMMENTS: createFlag("sport_pool_match_comments", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    HORSE_BET_HISTORY_AWS: createFlag("horse_bet_history_aws", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    HARRY_SUGGESTIONS_AWS: createFlag("harry_suggestions_aws", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    PAW_NEW_CLIENT_LOGGER: createFlag("paw_new_client_logger", {
        variations: ["on", "off"],
        fallbackVariation: "off",
        variables: {
            legacy_logger_active: {
                type: "boolean",
                defaultValue: true,
            },
        },
    }),
    TILLSAMMANS_CHAT_V3: createFlag("tillsammans_chat_v3", {
        fallbackVariation: "off",
    }),
    HAAPI_POLLER_DIAGNOSTICS_LOGGING: createFlag("haapi_poller_diagnostics_logging", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    ELLI_V2_MFE: createFlag("elli_v2_mfe", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    WITHDRAW_SHORT_FE_TIMEOUT: createFlag("withdraw_short_fe_timeout", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    TILLSAMMANS_MAKE_HORSE_GAMING_GREAT_AGAIN: createFlag(
        "tillsammans_make_horse_gaming_great_again",
        {
            variations: ["on", "off"],
            fallbackVariation: "off",
        },
    ),
    TILLSAMMANS_V7_ENABLED: createFlag("tillsammans_v7_enabled", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    NEW_DEPOSIT_MODAL_WITH_ZIMPLER: createFlag("new_deposit_modal_with_zimpler", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    HARRY_SUGGESTIONS_ITERATION_2: createFlag("harry_suggestions_iteration_2", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    HARRY_BOY_POPULAR_AMOUNT_A_B_TEST: createFlag("harry_boy_popular_amount_a_b_test", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    TILLSAMMANS_FORWARD_PREBOOKING_NOTICE: createFlag(
        "tillsammans_forward_prebooking_notice",
        {
            variations: ["on", "off"],
            fallbackVariation: "off",
        },
    ),
    GLOBAL_EXPERIENCE_ENABLE_V75: createFlag("global_experience_enable_v75", {
        fallbackVariation: "off",
    }),
    HARRY_BOY_THINKING_A_B_TEST: createFlag("harry_boy_thinking_a_b_test", {
        variations: ["on", "off"],
        fallbackVariation: "off",
    }),
    HORSE_STARTLIST_GAME_MENU_ANDELSSPEL_LINK: createFlag(
        "horse_startlist_game_menu_andelsspel_link",
        {
            variations: ["shop", "private", "off"],
            fallbackVariation: "off",
        },
    ),
} as const;
